import { gql, useLazyQuery, useMutation } from "@apollo/client";
import { useCallback, useEffect, useRef, useState } from "react";
import { RiErrorWarningFill } from "react-icons/ri";
import { useDispatch, useSelector } from "react-redux";
import { replaceUnderscore } from "../../../../CommonFunction/common";
import { FormInputSectionComponent } from "../../FormInputSectionComponent/FormInputSectionComponent";
import PortalFooter from "../../Reactportal/PortalFooter";
import Reactportal from "../../Reactportal/Reactportal";
import { ErrorToast, SuccessToast } from "../../ToastComponent/RectHotToast";
import ".././FormComponent.scss";
import { MaterialCategoryField, MaterialCategoryForMerge } from "./AddMaterialCategory.config";
import { ClearSpecificForm } from "../../../../Store/FormDataReducer/FormFieldFunctions";
import { useModalContext } from "../../Reactportal/ModalContext";
import { useEventListener } from "usehooks-ts";
import { handleFormReset, updateValueForm } from "../../FormInputSectionComponent/formUtils";
import useSubmitOperation, {
  getMutationFunction,
  handleFormSubmission,
  usePrepareGraphQLVariables,
} from "../../../../CommonFunction/CustomUseFormSubmission";
import {
  CreateMaterialCatagory,
  EditMaterialCategory,
  GetMaterialCategoryById,
  REPLACE_MATERIAL_CATEGORY,
} from "../../../../Utils/AllPagesQuriesAndMutations";

const AddMaterialCategory = ({
  show,
  id,
  TypeOfPortal,
  submitType,
  ParentPortalCloseFunction,
  ReferenceFieldName = [],
  ReferFormKey = "",
}) => {
  const Form_Key = "Material_Category";
  const { pushModal, popModal, getTopModal } = useModalContext();
  const formRef = useRef({});
  const [toggle, settoggle] = useState(show ? show : false);
  const [field, setFields] = useState(TypeOfPortal === "Merge" ? MaterialCategoryForMerge : MaterialCategoryField);
  const fielddataRedux = useSelector((store) => store.UniqueTableReducer);
  const fielddata = fielddataRedux?.Material_Category?.Selected_Row;
  const [allFieldsData, setAllFieldsData] = useState({});
  const [selectedRows, setSelectedRows] = useState([]);
  const [SubmitModal, SetSubmitModal] = useState(false);
  const dispatch = useDispatch();
  const [FormData, setFormdata] = useState({});
  const FormDataFromRedux = useSelector((store) => store?.FormDataReducer);
  const [CreatingData, { loading: MaterialCategoryLoading }] = useMutation(CreateMaterialCatagory, {
    fetchPolicy: "network-only",
    context: {
      headers: { "X-GraphQL-Server": "secondary" },
    },
  });

  const [getMaterialCategoryById, { loading: getMaterialCategoryByIdLoader }] = useLazyQuery(GetMaterialCategoryById, {
    fetchPolicy: "network-only",
    context: {
      headers: { "X-GraphQL-Server": "secondary" },
    },
  });

  const [EditingData, { loading: EditMaterialCategoryLoading }] = useMutation(EditMaterialCategory, {
    fetchPolicy: "network-only",
    context: {
      headers: { "X-GraphQL-Server": "secondary" },
    },
  });

  const [MergingData, { loading: ReplaceMaterialCategoryLoading }] = useMutation(REPLACE_MATERIAL_CATEGORY, {
    fetchPolicy: "network-only",
    context: {
      headers: { "X-GraphQL-Server": "secondary" },
    },
  });

  const MenuMasterLoadingState =
    MaterialCategoryLoading ||
    ReplaceMaterialCategoryLoading ||
    EditMaterialCategoryLoading ||
    getMaterialCategoryByIdLoader;

  const HanldeChangeonForm = (values) => {
    setFormdata((prev) => ({
      ...prev,
      ...values,
    }));
  };

  useEffect(() => {
    setSelectedRows(fielddataRedux?.Material_Category?.Selected_Rows);
  }, [fielddataRedux]);

  useEffect(() => {
    if (TypeOfPortal !== "Add"&& TypeOfPortal !== "Delete") {
      getMaterialCategoryById({
        variables: {
          id: fielddata?._id,
        },
      }).then(({ data }) => {
        let MaterialCategoryData = { ...data?.MaterialCategoryMasterByID };
        setAllFieldsData(MaterialCategoryData);
        updateValueForm(formRef, MaterialCategoryData);
      });
    }
  }, [fielddata]);

  useEffect(() => {
    if (toggle) {
      pushModal(Form_Key);
    }
  }, [toggle, Form_Key, pushModal]);

  const { executeOperation } = useSubmitOperation();
  const operationType = TypeOfPortal;
  let formData = !TypeOfPortal.includes("Merge")
    ? FormData
    : {
        existingId: fielddata._id,
        newId: FormDataFromRedux?.MasterData[Form_Key]?.replace_with?._id,
      };
  const variables = usePrepareGraphQLVariables(operationType, allFieldsData, formData, selectedRows);

  const MaterialCategoryMutations = {
    CreatingData,
    EditingData,
    MergingData,
  };

  const submit = async (closeAction) => {
    let Name = ReferenceFieldName[0]?.name;

    const mutationFunction = getMutationFunction(operationType, MaterialCategoryMutations);
    const executeOperationFunction = () =>
      executeOperation({
        operationType,
        data: formData,
        selectedRows,
        Mutation: () => mutationFunction({ variables }),
        processDataBeforeSubmit: (data) => data,
        PageName: Form_Key,
        OnSuccess: (res) => {
          dispatch({
            type: "StoreMasterData",
            payload: {
              formkey: ReferFormKey,
              data: {
                [Name]: res?.data?.createERPAddressBook || res?.data?.editERPAddressBook,
              },
            },
          });
          handleFormReset(formRef);
        },
      });
    handleFormSubmission(executeOperationFunction, {
      dispatch,
      operationType,
      closeAction,
      closeFormFunction: Closeformfunction,
      resetFormDataFunction: () => {
        setAllFieldsData();
        handleFormReset(formRef);
      },
      onSuccess: () => {},
      onError: (error) => {
        ErrorToast(error.message);
      },
    });
  };

  const Closeformfunction = () => {
    popModal(Form_Key);
    ParentPortalCloseFunction();
    settoggle(false);
    setAllFieldsData({});
    ClearSpecificForm(dispatch, Form_Key);
  };

  const SaveAndCloseForAdd = () => {
    submit("Close");
  };

  const ConfirmModalOpen = () => {
    SetSubmitModal(true);
  };

  const handleKeyDown = (event) => {
    if (getTopModal() === Form_Key) {
      if (event.key === "Escape") {
        Closeformfunction();
      } else if (event.key === "F4" && !TypeOfPortal?.includes("View")) {
        SaveAndCloseForAdd();
        Closeformfunction();
      }
    }
  };

  useEventListener("keydown", handleKeyDown);

  const footerContent = (
    <PortalFooter
      renderContent={() => <></>}
      disabled={false}
      submitform={submit}
      submitType={submitType}
      SaveAndClose={TypeOfPortal === "Add" ? SaveAndCloseForAdd : TypeOfPortal === "Merge" ? ConfirmModalOpen : submit}
      handleformclose={() => {
        Closeformfunction();
        settoggle(!toggle);
      }}
      loadingState={MenuMasterLoadingState}
    />
  );
  return (
    <>
      <div>
        <Reactportal
          FoooterContent={footerContent}
          open={toggle}
          onClose={Closeformfunction}
          TypeOfPortal={TypeOfPortal + " Material Category"}
        >
          {MenuMasterLoadingState && <div className="loader-line-div" />}
          <div className="formContainer">
            {field.map((e, i) => {
              return (
                <div key={i} className="FormSectionParent">
                  <div className="sectionHeadings">{replaceUnderscore(e.name)}</div>
                  <div className="FormSection insidecontainer">
                    <FormInputSectionComponent
                      accountId=""
                      inputfields={e.fields}
                      Type={e.name}
                      fielddata={allFieldsData}
                      onhandleFormikChange={HanldeChangeonForm}
                      formkey={Form_Key}
                      formRef={formRef}
                    />
                  </div>
                </div>
              );
            })}
          </div>
        </Reactportal>
      </div>
      {SubmitModal && (
        <Reactportal open={SubmitModal} onClose={() => SetSubmitModal(false)} TypeOfPortal={"Confirm"}>
          <div className="warning">
            <RiErrorWarningFill className="warningIcon" />
            <p className="warningMsg">Are You Sure You Want to Merge This Record?</p>
          </div>

          <PortalFooter
            renderContent={() => <></>}
            disabled={false}
            submitform={submit}
            submitType={"Confirm Merge"}
            handleformclose={() => {
              SetSubmitModal(!toggle);
            }}
            SaveAndClose={() => {}}
            loadingState={false}
            disableupload={false}
          />
        </Reactportal>
      )}
    </>
  );
};

export default AddMaterialCategory;
